import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressTracker = ({ completed, total, locked = true }) => {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;
  
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="Target" size={20} color="var(--color-success)" strokeWidth={2} />
          </div>
          <div>
            <h3 className="text-base font-semibold text-foreground">Learning Progress</h3>
            <p className="text-xs text-muted-foreground">Track your knowledge journey</p>
          </div>
        </div>
        {locked && (
          <Icon name="Lock" size={18} color="var(--color-muted-foreground)" />
        )}
      </div>
      
      <div className="space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Completed</span>
          <span className="font-semibold text-foreground">{completed} / {total}</span>
        </div>
        <div className="relative h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="absolute top-0 left-0 h-full bg-gradient-to-r from-success to-primary rounded-full transition-all duration-500"
            style={{ width: `${percentage}%` }}
          />
        </div>
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>0%</span>
          <span className="font-semibold text-primary">{percentage}%</span>
          <span>100%</span>
        </div>
      </div>
    </div>
  );
};

export default ProgressTracker;